import { FormikConsumer } from 'formik';

export const Debug = () => (
  <div
    style={{
      margin: '3rem 0',
      borderRadius: 4,
      background: '#f6f8fa',
      boxShadow: '0 0 1px  #eee inset',
    }}
  >
    <div
      style={{
        textTransform: 'uppercase',
        fontSize: 11,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        fontWeight: 500,
        padding: '.5rem',
        background: '#555',
        color: '#fff',
        letterSpacing: '1px',
      }}
    >
      Formik State
    </div>
    <FormikConsumer>
      {/* @ts-expect-error TS(2339): Property 'onSubmit' does not exist on type 'Formik... Remove this comment to see the full error message */}
      {({ validationSchema, validate, onSubmit, ...rest }) => (
        <pre
          style={{
            padding: '.25rem .5rem',
            overflowX: 'scroll',
            fontSize: 11,
          }}
        >
          {JSON.stringify(rest, null, 2)}
        </pre>
      )}
    </FormikConsumer>
  </div>
);
